module.exports = __webpack_public_path__ + "img/k4.e03e6c74.jpg";